import { useIntl } from '@umijs/max';
import { getBrandFooterCopyright } from 'config/brand';
import React from 'react';

const Footer: React.FC = () => {
  const intl = useIntl();

  return (
    <footer
      style={{
        background: 'none',
        color: 'rgba(0, 0, 0, 0.45)',
        fontSize: 14,
        paddingBlock: 24,
        textAlign: 'center',
      }}
    >
      {getBrandFooterCopyright(intl.locale)}
    </footer>
  );
};

export default Footer;
